import { useEffect, useState } from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import LinkIcon from "@mui/icons-material/Link"
import { MONO, CHAT_COLOR } from "../constants"
import { firstPreviewUrl } from "../utils/linkPreview"


export function LinkPreview({ text }) {
  const url = firstPreviewUrl(text)
  const [preview, setPreview] = useState(null)

  useEffect(() => {
    setPreview(null)
    if (!url) return undefined
    const controller = new AbortController()
    fetch("/api/messenger/link-preview/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ url }),
      signal: controller.signal,
    })
      .then(response => response.ok ? response.json() : null)
      .then(data => { if (data?.preview) setPreview(data.preview) })
      .catch(() => {})
    return () => controller.abort()
  }, [url])

  if (!preview) return null
  return (
    <Box component="a" href={preview.url}
      sx={{ display: "block", mt: 0.65, px: 1, py: 0.7, maxWidth: 280, borderRadius: "7px",
        color: "inherit", textDecoration: "none", backgroundColor: "rgba(var(--app-fg-rgb),0.035)",
        borderLeft: `2px solid ${CHAT_COLOR}`, "&:hover": { backgroundColor: "rgba(245,158,11,0.07)" } }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.25 }}>
        <LinkIcon sx={{ fontSize: 11, color: CHAT_COLOR }} />
        <Typography sx={{ fontFamily: MONO, fontSize: "0.55rem", color: CHAT_COLOR,
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {preview.site}
        </Typography>
      </Box>
      <Typography sx={{ fontFamily: MONO, fontSize: "0.65rem", color: "rgba(var(--app-fg-rgb),0.88)",
        fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {preview.title}
      </Typography>
      {preview.description && (
        <Typography sx={{ mt: 0.25, fontFamily: MONO, fontSize: "0.58rem", lineHeight: 1.35,
          color: "rgba(var(--app-fg-rgb),0.45)", display: "-webkit-box", WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical", overflow: "hidden" }}>
          {preview.description}
        </Typography>
      )}
    </Box>
  )
}

export default LinkPreview
